"use strict";

const LocalStorage = require("app/util/browser/local-storage");
const moment = require("moment");

const tasksFilterStorage = new LocalStorage("agendor-activity-filters-tasks", {
  userId: window ? window.loggedUserId : "",
  offset: 0,
  page: 1
});

const calendarColorStorage = new LocalStorage("agendor-calendar-color-scheme", "");

const dateFormat = "YYYY-MM-DD HH:mm:ss";
const homeFilterStorage = new LocalStorage("agendor-activity-filters-home", {
  created_by_user_id: "",
  initial_creation_date: moment().subtract(1, "week").startOf("day").format(dateFormat),
  final_creation_date: moment().endOf("day").format(dateFormat),
})

module.exports = {
  activityFilters: tasksFilterStorage,
  calendarColorScheme: calendarColorStorage,
  homeFilters: homeFilterStorage
};



// WEBPACK FOOTER //
// ./app/util/browser/user-preferences.js